// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file folder/v1/folders.proto (package folder.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ArchiveReason, ArchiveReasonJson, AssetState, AssetStateJson, CreationMethod, CreationMethodJson, DateRange, DateRangeJson, Destination, DestinationJson } from "../../asset/v1/asset_pb";
import { file_asset_v1_asset } from "../../asset/v1/asset_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file folder/v1/folders.proto.
 */
export const file_folder_v1_folders: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_asset_v1_asset, file_common_v1_annotations, file_common_v1_pagination, file_google_protobuf_timestamp],
	);

/**
 * @generated from message folder.v1.Folder
 */
export type Folder = Message<"folder.v1.Folder"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * @generated from field: string description = 5;
	 */
	description: string;

	/**
	 * @generated from field: string path = 6;
	 */
	path: string;

	/**
	 * @generated from field: string creator_id = 7;
	 */
	creatorId: string;

	/**
	 * @generated from field: asset.v1.AssetState state = 8;
	 */
	state: AssetState;

	/**
	 * @generated from field: asset.v1.CreationMethod creation_method = 9;
	 */
	creationMethod: CreationMethod;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: optional google.protobuf.Timestamp archived_at = 12;
	 */
	archivedAt?: Timestamp | undefined;

	/**
	 * @generated from field: bool is_hidden = 13;
	 */
	isHidden: boolean;
};

/**
 * @generated from message folder.v1.Folder
 */
export type FolderJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 5;
	 */
	description?: string;

	/**
	 * @generated from field: string path = 6;
	 */
	path?: string;

	/**
	 * @generated from field: string creator_id = 7;
	 */
	creatorId?: string;

	/**
	 * @generated from field: asset.v1.AssetState state = 8;
	 */
	state?: AssetStateJson;

	/**
	 * @generated from field: asset.v1.CreationMethod creation_method = 9;
	 */
	creationMethod?: CreationMethodJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp archived_at = 12;
	 */
	archivedAt?: TimestampJson;

	/**
	 * @generated from field: bool is_hidden = 13;
	 */
	isHidden?: boolean;
};

/**
 * Describes the message folder.v1.Folder.
 * Use `create(FolderSchema)` to create a new message.
 */
export const FolderSchema: GenMessage<Folder, { jsonType: FolderJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 0);

/**
 * @generated from message folder.v1.GetFolderRequest
 */
export type GetFolderRequest = Message<"folder.v1.GetFolderRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message folder.v1.GetFolderRequest
 */
export type GetFolderRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message folder.v1.GetFolderRequest.
 * Use `create(GetFolderRequestSchema)` to create a new message.
 */
export const GetFolderRequestSchema: GenMessage<GetFolderRequest, { jsonType: GetFolderRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 1);

/**
 * @generated from message folder.v1.GetFolderResponse
 */
export type GetFolderResponse = Message<"folder.v1.GetFolderResponse"> & {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: Folder | undefined;
};

/**
 * @generated from message folder.v1.GetFolderResponse
 */
export type GetFolderResponseJson = {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: FolderJson;
};

/**
 * Describes the message folder.v1.GetFolderResponse.
 * Use `create(GetFolderResponseSchema)` to create a new message.
 */
export const GetFolderResponseSchema: GenMessage<GetFolderResponse, { jsonType: GetFolderResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 2);

/**
 * @generated from message folder.v1.ValidateFolderNameRequest
 */
export type ValidateFolderNameRequest = Message<"folder.v1.ValidateFolderNameRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string parent_path = 3;
	 */
	parentPath: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name: string;
};

/**
 * @generated from message folder.v1.ValidateFolderNameRequest
 */
export type ValidateFolderNameRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string parent_path = 3;
	 */
	parentPath?: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name?: string;
};

/**
 * Describes the message folder.v1.ValidateFolderNameRequest.
 * Use `create(ValidateFolderNameRequestSchema)` to create a new message.
 */
export const ValidateFolderNameRequestSchema: GenMessage<ValidateFolderNameRequest, { jsonType: ValidateFolderNameRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 3);

/**
 * @generated from message folder.v1.ValidateFolderNameResponse
 */
export type ValidateFolderNameResponse = Message<"folder.v1.ValidateFolderNameResponse"> & {
	/**
	 * @generated from field: bool valid = 1;
	 */
	valid: boolean;

	/**
	 * @generated from field: string error_message = 2;
	 */
	errorMessage: string;
};

/**
 * @generated from message folder.v1.ValidateFolderNameResponse
 */
export type ValidateFolderNameResponseJson = {
	/**
	 * @generated from field: bool valid = 1;
	 */
	valid?: boolean;

	/**
	 * @generated from field: string error_message = 2;
	 */
	errorMessage?: string;
};

/**
 * Describes the message folder.v1.ValidateFolderNameResponse.
 * Use `create(ValidateFolderNameResponseSchema)` to create a new message.
 */
export const ValidateFolderNameResponseSchema: GenMessage<ValidateFolderNameResponse, { jsonType: ValidateFolderNameResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 4);

/**
 * @generated from message folder.v1.GetFoldersInPathRequest
 */
export type GetFoldersInPathRequest = Message<"folder.v1.GetFoldersInPathRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string path = 3;
	 */
	path: string;
};

/**
 * @generated from message folder.v1.GetFoldersInPathRequest
 */
export type GetFoldersInPathRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string path = 3;
	 */
	path?: string;
};

/**
 * Describes the message folder.v1.GetFoldersInPathRequest.
 * Use `create(GetFoldersInPathRequestSchema)` to create a new message.
 */
export const GetFoldersInPathRequestSchema: GenMessage<GetFoldersInPathRequest, { jsonType: GetFoldersInPathRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 5);

/**
 * @generated from message folder.v1.GetFoldersInPathResponse
 */
export type GetFoldersInPathResponse = Message<"folder.v1.GetFoldersInPathResponse"> & {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders: Folder[];
};

/**
 * @generated from message folder.v1.GetFoldersInPathResponse
 */
export type GetFoldersInPathResponseJson = {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders?: FolderJson[];
};

/**
 * Describes the message folder.v1.GetFoldersInPathResponse.
 * Use `create(GetFoldersInPathResponseSchema)` to create a new message.
 */
export const GetFoldersInPathResponseSchema: GenMessage<GetFoldersInPathResponse, { jsonType: GetFoldersInPathResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 6);

/**
 * @generated from message folder.v1.GetFoldersByIdsRequest
 */
export type GetFoldersByIdsRequest = Message<"folder.v1.GetFoldersByIdsRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];
};

/**
 * @generated from message folder.v1.GetFoldersByIdsRequest
 */
export type GetFoldersByIdsRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];
};

/**
 * Describes the message folder.v1.GetFoldersByIdsRequest.
 * Use `create(GetFoldersByIdsRequestSchema)` to create a new message.
 */
export const GetFoldersByIdsRequestSchema: GenMessage<GetFoldersByIdsRequest, { jsonType: GetFoldersByIdsRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 7);

/**
 * @generated from message folder.v1.GetFoldersByIdsResponse
 */
export type GetFoldersByIdsResponse = Message<"folder.v1.GetFoldersByIdsResponse"> & {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders: Folder[];
};

/**
 * @generated from message folder.v1.GetFoldersByIdsResponse
 */
export type GetFoldersByIdsResponseJson = {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders?: FolderJson[];
};

/**
 * Describes the message folder.v1.GetFoldersByIdsResponse.
 * Use `create(GetFoldersByIdsResponseSchema)` to create a new message.
 */
export const GetFoldersByIdsResponseSchema: GenMessage<GetFoldersByIdsResponse, { jsonType: GetFoldersByIdsResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 8);

/**
 * @generated from message folder.v1.GetFolderPathsByIdsRequest
 */
export type GetFolderPathsByIdsRequest = Message<"folder.v1.GetFolderPathsByIdsRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];
};

/**
 * @generated from message folder.v1.GetFolderPathsByIdsRequest
 */
export type GetFolderPathsByIdsRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];
};

/**
 * Describes the message folder.v1.GetFolderPathsByIdsRequest.
 * Use `create(GetFolderPathsByIdsRequestSchema)` to create a new message.
 */
export const GetFolderPathsByIdsRequestSchema: GenMessage<GetFolderPathsByIdsRequest, { jsonType: GetFolderPathsByIdsRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 9);

/**
 * @generated from message folder.v1.GetFolderPathsByIdsResponse
 */
export type GetFolderPathsByIdsResponse = Message<"folder.v1.GetFolderPathsByIdsResponse"> & {
	/**
	 * @generated from field: map<string, string> paths = 1;
	 */
	paths: { [key: string]: string };
};

/**
 * @generated from message folder.v1.GetFolderPathsByIdsResponse
 */
export type GetFolderPathsByIdsResponseJson = {
	/**
	 * @generated from field: map<string, string> paths = 1;
	 */
	paths?: { [key: string]: string };
};

/**
 * Describes the message folder.v1.GetFolderPathsByIdsResponse.
 * Use `create(GetFolderPathsByIdsResponseSchema)` to create a new message.
 */
export const GetFolderPathsByIdsResponseSchema: GenMessage<GetFolderPathsByIdsResponse, { jsonType: GetFolderPathsByIdsResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 10);

/**
 * @generated from message folder.v1.FolderFilter
 */
export type FolderFilter = Message<"folder.v1.FolderFilter"> & {
	/**
	 * @generated from field: optional string path = 1;
	 */
	path?: string | undefined;

	/**
	 * returns folders only in the provides states
	 *
	 * @generated from field: repeated asset.v1.AssetState states = 2;
	 */
	states: AssetState[];

	/**
	 * returns folders by the creator(s)
	 *
	 * @generated from field: repeated string creator_ids = 3;
	 */
	creatorIds: string[];

	/**
	 * CreatedAtDateRange scopes the response to folders created in the specified range. The filter is exclusive
	 *
	 * When start_date is empty the filtering will get everything created up to end_date
	 * When end_date is empty the filtering will get everything created from the start_date up until now
	 *
	 * @generated from field: optional asset.v1.DateRange created_at_date_range = 4;
	 */
	createdAtDateRange?: DateRange | undefined;

	/**
	 * returns folders that match the supplied name prefix
	 *
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix: string;

	/**
	 * not supported on folders
	 *
	 * @generated from field: repeated string tags = 6;
	 */
	tags: string[];

	/**
	 * includes hidden folders if true
	 *
	 * @generated from field: bool include_hidden = 7;
	 */
	includeHidden: boolean;

	/**
	 * includes descendant folders if true
	 *
	 * @generated from field: bool include_descendants = 8;
	 */
	includeDescendants: boolean;
};

/**
 * @generated from message folder.v1.FolderFilter
 */
export type FolderFilterJson = {
	/**
	 * @generated from field: optional string path = 1;
	 */
	path?: string;

	/**
	 * returns folders only in the provides states
	 *
	 * @generated from field: repeated asset.v1.AssetState states = 2;
	 */
	states?: AssetStateJson[];

	/**
	 * returns folders by the creator(s)
	 *
	 * @generated from field: repeated string creator_ids = 3;
	 */
	creatorIds?: string[];

	/**
	 * CreatedAtDateRange scopes the response to folders created in the specified range. The filter is exclusive
	 *
	 * When start_date is empty the filtering will get everything created up to end_date
	 * When end_date is empty the filtering will get everything created from the start_date up until now
	 *
	 * @generated from field: optional asset.v1.DateRange created_at_date_range = 4;
	 */
	createdAtDateRange?: DateRangeJson;

	/**
	 * returns folders that match the supplied name prefix
	 *
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix?: string;

	/**
	 * not supported on folders
	 *
	 * @generated from field: repeated string tags = 6;
	 */
	tags?: string[];

	/**
	 * includes hidden folders if true
	 *
	 * @generated from field: bool include_hidden = 7;
	 */
	includeHidden?: boolean;

	/**
	 * includes descendant folders if true
	 *
	 * @generated from field: bool include_descendants = 8;
	 */
	includeDescendants?: boolean;
};

/**
 * Describes the message folder.v1.FolderFilter.
 * Use `create(FolderFilterSchema)` to create a new message.
 */
export const FolderFilterSchema: GenMessage<FolderFilter, { jsonType: FolderFilterJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 11);

/**
 * @generated from message folder.v1.ListFoldersRequest
 */
export type ListFoldersRequest = Message<"folder.v1.ListFoldersRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArguments | undefined;

	/**
	 * @generated from field: optional folder.v1.FolderFilter filter = 4;
	 */
	filter?: FolderFilter | undefined;
};

/**
 * @generated from message folder.v1.ListFoldersRequest
 */
export type ListFoldersRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArgumentsJson;

	/**
	 * @generated from field: optional folder.v1.FolderFilter filter = 4;
	 */
	filter?: FolderFilterJson;
};

/**
 * Describes the message folder.v1.ListFoldersRequest.
 * Use `create(ListFoldersRequestSchema)` to create a new message.
 */
export const ListFoldersRequestSchema: GenMessage<ListFoldersRequest, { jsonType: ListFoldersRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 12);

/**
 * @generated from message folder.v1.ListFoldersResponse
 */
export type ListFoldersResponse = Message<"folder.v1.ListFoldersResponse"> & {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders: Folder[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message folder.v1.ListFoldersResponse
 */
export type ListFoldersResponseJson = {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders?: FolderJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message folder.v1.ListFoldersResponse.
 * Use `create(ListFoldersResponseSchema)` to create a new message.
 */
export const ListFoldersResponseSchema: GenMessage<ListFoldersResponse, { jsonType: ListFoldersResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 13);

/**
 * @generated from message folder.v1.CreateFolderRequest
 */
export type CreateFolderRequest = Message<"folder.v1.CreateFolderRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: string parent_path = 5;
	 */
	parentPath: string;
};

/**
 * @generated from message folder.v1.CreateFolderRequest
 */
export type CreateFolderRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: string parent_path = 5;
	 */
	parentPath?: string;
};

/**
 * Describes the message folder.v1.CreateFolderRequest.
 * Use `create(CreateFolderRequestSchema)` to create a new message.
 */
export const CreateFolderRequestSchema: GenMessage<CreateFolderRequest, { jsonType: CreateFolderRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 14);

/**
 * @generated from message folder.v1.CreateFolderResponse
 */
export type CreateFolderResponse = Message<"folder.v1.CreateFolderResponse"> & {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: Folder | undefined;
};

/**
 * @generated from message folder.v1.CreateFolderResponse
 */
export type CreateFolderResponseJson = {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: FolderJson;
};

/**
 * Describes the message folder.v1.CreateFolderResponse.
 * Use `create(CreateFolderResponseSchema)` to create a new message.
 */
export const CreateFolderResponseSchema: GenMessage<CreateFolderResponse, { jsonType: CreateFolderResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 15);

/**
 * @generated from message folder.v1.UpdateFolderRequest
 */
export type UpdateFolderRequest = Message<"folder.v1.UpdateFolderRequest"> & {
	/**
	 * The id of the folder
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * Optionally update the folder name
	 *
	 * @generated from field: optional string name = 3;
	 */
	name?: string | undefined;

	/**
	 * Optionally update the folder description
	 *
	 * @generated from field: optional string description = 4;
	 */
	description?: string | undefined;
};

/**
 * @generated from message folder.v1.UpdateFolderRequest
 */
export type UpdateFolderRequestJson = {
	/**
	 * The id of the folder
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * Optionally update the folder name
	 *
	 * @generated from field: optional string name = 3;
	 */
	name?: string;

	/**
	 * Optionally update the folder description
	 *
	 * @generated from field: optional string description = 4;
	 */
	description?: string;
};

/**
 * Describes the message folder.v1.UpdateFolderRequest.
 * Use `create(UpdateFolderRequestSchema)` to create a new message.
 */
export const UpdateFolderRequestSchema: GenMessage<UpdateFolderRequest, { jsonType: UpdateFolderRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 16);

/**
 * @generated from message folder.v1.UpdateFolderResponse
 */
export type UpdateFolderResponse = Message<"folder.v1.UpdateFolderResponse"> & {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: Folder | undefined;
};

/**
 * @generated from message folder.v1.UpdateFolderResponse
 */
export type UpdateFolderResponseJson = {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: FolderJson;
};

/**
 * Describes the message folder.v1.UpdateFolderResponse.
 * Use `create(UpdateFolderResponseSchema)` to create a new message.
 */
export const UpdateFolderResponseSchema: GenMessage<UpdateFolderResponse, { jsonType: UpdateFolderResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 17);

/**
 * @generated from message folder.v1.ArchiveFolderRequest
 */
export type ArchiveFolderRequest = Message<"folder.v1.ArchiveFolderRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: asset.v1.ArchiveReason archive_reason = 2;
	 */
	archiveReason: ArchiveReason;
};

/**
 * @generated from message folder.v1.ArchiveFolderRequest
 */
export type ArchiveFolderRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: asset.v1.ArchiveReason archive_reason = 2;
	 */
	archiveReason?: ArchiveReasonJson;
};

/**
 * Describes the message folder.v1.ArchiveFolderRequest.
 * Use `create(ArchiveFolderRequestSchema)` to create a new message.
 */
export const ArchiveFolderRequestSchema: GenMessage<ArchiveFolderRequest, { jsonType: ArchiveFolderRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 18);

/**
 * @generated from message folder.v1.ArchiveFolderResponse
 */
export type ArchiveFolderResponse = Message<"folder.v1.ArchiveFolderResponse"> & {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: Folder | undefined;
};

/**
 * @generated from message folder.v1.ArchiveFolderResponse
 */
export type ArchiveFolderResponseJson = {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: FolderJson;
};

/**
 * Describes the message folder.v1.ArchiveFolderResponse.
 * Use `create(ArchiveFolderResponseSchema)` to create a new message.
 */
export const ArchiveFolderResponseSchema: GenMessage<ArchiveFolderResponse, { jsonType: ArchiveFolderResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 19);

/**
 * @generated from message folder.v1.RestoreFolderRequest
 */
export type RestoreFolderRequest = Message<"folder.v1.RestoreFolderRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message folder.v1.RestoreFolderRequest
 */
export type RestoreFolderRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message folder.v1.RestoreFolderRequest.
 * Use `create(RestoreFolderRequestSchema)` to create a new message.
 */
export const RestoreFolderRequestSchema: GenMessage<RestoreFolderRequest, { jsonType: RestoreFolderRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 20);

/**
 * @generated from message folder.v1.RestoreFolderResponse
 */
export type RestoreFolderResponse = Message<"folder.v1.RestoreFolderResponse"> & {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: Folder | undefined;
};

/**
 * @generated from message folder.v1.RestoreFolderResponse
 */
export type RestoreFolderResponseJson = {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: FolderJson;
};

/**
 * Describes the message folder.v1.RestoreFolderResponse.
 * Use `create(RestoreFolderResponseSchema)` to create a new message.
 */
export const RestoreFolderResponseSchema: GenMessage<RestoreFolderResponse, { jsonType: RestoreFolderResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 21);

/**
 * @generated from message folder.v1.ArchiveFoldersRequest
 */
export type ArchiveFoldersRequest = Message<"folder.v1.ArchiveFoldersRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];

	/**
	 * @generated from field: asset.v1.ArchiveReason archive_reason = 2;
	 */
	archiveReason: ArchiveReason;
};

/**
 * @generated from message folder.v1.ArchiveFoldersRequest
 */
export type ArchiveFoldersRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];

	/**
	 * @generated from field: asset.v1.ArchiveReason archive_reason = 2;
	 */
	archiveReason?: ArchiveReasonJson;
};

/**
 * Describes the message folder.v1.ArchiveFoldersRequest.
 * Use `create(ArchiveFoldersRequestSchema)` to create a new message.
 */
export const ArchiveFoldersRequestSchema: GenMessage<ArchiveFoldersRequest, { jsonType: ArchiveFoldersRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 22);

/**
 * @generated from message folder.v1.ArchiveFoldersResponse
 */
export type ArchiveFoldersResponse = Message<"folder.v1.ArchiveFoldersResponse"> & {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders: Folder[];
};

/**
 * @generated from message folder.v1.ArchiveFoldersResponse
 */
export type ArchiveFoldersResponseJson = {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders?: FolderJson[];
};

/**
 * Describes the message folder.v1.ArchiveFoldersResponse.
 * Use `create(ArchiveFoldersResponseSchema)` to create a new message.
 */
export const ArchiveFoldersResponseSchema: GenMessage<ArchiveFoldersResponse, { jsonType: ArchiveFoldersResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 23);

/**
 * @generated from message folder.v1.RestoreFoldersRequest
 */
export type RestoreFoldersRequest = Message<"folder.v1.RestoreFoldersRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];
};

/**
 * @generated from message folder.v1.RestoreFoldersRequest
 */
export type RestoreFoldersRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];
};

/**
 * Describes the message folder.v1.RestoreFoldersRequest.
 * Use `create(RestoreFoldersRequestSchema)` to create a new message.
 */
export const RestoreFoldersRequestSchema: GenMessage<RestoreFoldersRequest, { jsonType: RestoreFoldersRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 24);

/**
 * @generated from message folder.v1.RestoreFoldersResponse
 */
export type RestoreFoldersResponse = Message<"folder.v1.RestoreFoldersResponse"> & {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders: Folder[];
};

/**
 * @generated from message folder.v1.RestoreFoldersResponse
 */
export type RestoreFoldersResponseJson = {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders?: FolderJson[];
};

/**
 * Describes the message folder.v1.RestoreFoldersResponse.
 * Use `create(RestoreFoldersResponseSchema)` to create a new message.
 */
export const RestoreFoldersResponseSchema: GenMessage<RestoreFoldersResponse, { jsonType: RestoreFoldersResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 25);

/**
 * @generated from message folder.v1.DeleteFolderRequest
 */
export type DeleteFolderRequest = Message<"folder.v1.DeleteFolderRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message folder.v1.DeleteFolderRequest
 */
export type DeleteFolderRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message folder.v1.DeleteFolderRequest.
 * Use `create(DeleteFolderRequestSchema)` to create a new message.
 */
export const DeleteFolderRequestSchema: GenMessage<DeleteFolderRequest, { jsonType: DeleteFolderRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 26);

/**
 * @generated from message folder.v1.DeleteFolderResponse
 */
export type DeleteFolderResponse = Message<"folder.v1.DeleteFolderResponse"> & {};

/**
 * @generated from message folder.v1.DeleteFolderResponse
 */
export type DeleteFolderResponseJson = {};

/**
 * Describes the message folder.v1.DeleteFolderResponse.
 * Use `create(DeleteFolderResponseSchema)` to create a new message.
 */
export const DeleteFolderResponseSchema: GenMessage<DeleteFolderResponse, { jsonType: DeleteFolderResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 27);

/**
 * @generated from message folder.v1.DeleteFoldersRequest
 */
export type DeleteFoldersRequest = Message<"folder.v1.DeleteFoldersRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];
};

/**
 * @generated from message folder.v1.DeleteFoldersRequest
 */
export type DeleteFoldersRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];
};

/**
 * Describes the message folder.v1.DeleteFoldersRequest.
 * Use `create(DeleteFoldersRequestSchema)` to create a new message.
 */
export const DeleteFoldersRequestSchema: GenMessage<DeleteFoldersRequest, { jsonType: DeleteFoldersRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 28);

/**
 * @generated from message folder.v1.DeleteFoldersResponse
 */
export type DeleteFoldersResponse = Message<"folder.v1.DeleteFoldersResponse"> & {};

/**
 * @generated from message folder.v1.DeleteFoldersResponse
 */
export type DeleteFoldersResponseJson = {};

/**
 * Describes the message folder.v1.DeleteFoldersResponse.
 * Use `create(DeleteFoldersResponseSchema)` to create a new message.
 */
export const DeleteFoldersResponseSchema: GenMessage<DeleteFoldersResponse, { jsonType: DeleteFoldersResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 29);

/**
 * @generated from message folder.v1.MoveFolderRequest
 */
export type MoveFolderRequest = Message<"folder.v1.MoveFolderRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: asset.v1.Destination destination = 2;
	 */
	destination?: Destination | undefined;

	/**
	 * @generated from field: optional bool ignore_analytics = 3;
	 */
	ignoreAnalytics?: boolean | undefined;
};

/**
 * @generated from message folder.v1.MoveFolderRequest
 */
export type MoveFolderRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: asset.v1.Destination destination = 2;
	 */
	destination?: DestinationJson;

	/**
	 * @generated from field: optional bool ignore_analytics = 3;
	 */
	ignoreAnalytics?: boolean;
};

/**
 * Describes the message folder.v1.MoveFolderRequest.
 * Use `create(MoveFolderRequestSchema)` to create a new message.
 */
export const MoveFolderRequestSchema: GenMessage<MoveFolderRequest, { jsonType: MoveFolderRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 30);

/**
 * @generated from message folder.v1.MoveFolderResponse
 */
export type MoveFolderResponse = Message<"folder.v1.MoveFolderResponse"> & {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: Folder | undefined;
};

/**
 * @generated from message folder.v1.MoveFolderResponse
 */
export type MoveFolderResponseJson = {
	/**
	 * @generated from field: folder.v1.Folder folder = 1;
	 */
	folder?: FolderJson;
};

/**
 * Describes the message folder.v1.MoveFolderResponse.
 * Use `create(MoveFolderResponseSchema)` to create a new message.
 */
export const MoveFolderResponseSchema: GenMessage<MoveFolderResponse, { jsonType: MoveFolderResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 31);

/**
 * @generated from message folder.v1.MoveFoldersRequest
 */
export type MoveFoldersRequest = Message<"folder.v1.MoveFoldersRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];

	/**
	 * @generated from field: asset.v1.Destination destination = 2;
	 */
	destination?: Destination | undefined;

	/**
	 * @generated from field: optional bool ignore_analytics = 3;
	 */
	ignoreAnalytics?: boolean | undefined;
};

/**
 * @generated from message folder.v1.MoveFoldersRequest
 */
export type MoveFoldersRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];

	/**
	 * @generated from field: asset.v1.Destination destination = 2;
	 */
	destination?: DestinationJson;

	/**
	 * @generated from field: optional bool ignore_analytics = 3;
	 */
	ignoreAnalytics?: boolean;
};

/**
 * Describes the message folder.v1.MoveFoldersRequest.
 * Use `create(MoveFoldersRequestSchema)` to create a new message.
 */
export const MoveFoldersRequestSchema: GenMessage<MoveFoldersRequest, { jsonType: MoveFoldersRequestJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 32);

/**
 * @generated from message folder.v1.MoveFoldersResponse
 */
export type MoveFoldersResponse = Message<"folder.v1.MoveFoldersResponse"> & {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders: Folder[];
};

/**
 * @generated from message folder.v1.MoveFoldersResponse
 */
export type MoveFoldersResponseJson = {
	/**
	 * @generated from field: repeated folder.v1.Folder folders = 1;
	 */
	folders?: FolderJson[];
};

/**
 * Describes the message folder.v1.MoveFoldersResponse.
 * Use `create(MoveFoldersResponseSchema)` to create a new message.
 */
export const MoveFoldersResponseSchema: GenMessage<MoveFoldersResponse, { jsonType: MoveFoldersResponseJson }> = /*@__PURE__*/ messageDesc(file_folder_v1_folders, 33);

/**
 * @generated from service folder.v1.FolderService
 */
export const FolderService: GenService<{
	/**
	 * @generated from rpc folder.v1.FolderService.CreateFolder
	 */
	createFolder: {
		methodKind: "unary";
		input: typeof CreateFolderRequestSchema;
		output: typeof CreateFolderResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.UpdateFolder
	 */
	updateFolder: {
		methodKind: "unary";
		input: typeof UpdateFolderRequestSchema;
		output: typeof UpdateFolderResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.ArchiveFolder
	 */
	archiveFolder: {
		methodKind: "unary";
		input: typeof ArchiveFolderRequestSchema;
		output: typeof ArchiveFolderResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.ArchiveFolders
	 */
	archiveFolders: {
		methodKind: "unary";
		input: typeof ArchiveFoldersRequestSchema;
		output: typeof ArchiveFoldersResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.RestoreFolder
	 */
	restoreFolder: {
		methodKind: "unary";
		input: typeof RestoreFolderRequestSchema;
		output: typeof RestoreFolderResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.RestoreFolders
	 */
	restoreFolders: {
		methodKind: "unary";
		input: typeof RestoreFoldersRequestSchema;
		output: typeof RestoreFoldersResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.DeleteFolder
	 */
	deleteFolder: {
		methodKind: "unary";
		input: typeof DeleteFolderRequestSchema;
		output: typeof DeleteFolderResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.DeleteFolders
	 */
	deleteFolders: {
		methodKind: "unary";
		input: typeof DeleteFoldersRequestSchema;
		output: typeof DeleteFoldersResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.MoveFolder
	 */
	moveFolder: {
		methodKind: "unary";
		input: typeof MoveFolderRequestSchema;
		output: typeof MoveFolderResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.MoveFolders
	 */
	moveFolders: {
		methodKind: "unary";
		input: typeof MoveFoldersRequestSchema;
		output: typeof MoveFoldersResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.GetFolder
	 */
	getFolder: {
		methodKind: "unary";
		input: typeof GetFolderRequestSchema;
		output: typeof GetFolderResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.GetFoldersInPath
	 */
	getFoldersInPath: {
		methodKind: "unary";
		input: typeof GetFoldersInPathRequestSchema;
		output: typeof GetFoldersInPathResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.GetFoldersByIds
	 */
	getFoldersByIds: {
		methodKind: "unary";
		input: typeof GetFoldersByIdsRequestSchema;
		output: typeof GetFoldersByIdsResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.GetFolderPathsByIds
	 */
	getFolderPathsByIds: {
		methodKind: "unary";
		input: typeof GetFolderPathsByIdsRequestSchema;
		output: typeof GetFolderPathsByIdsResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.ValidateFolderName
	 */
	validateFolderName: {
		methodKind: "unary";
		input: typeof ValidateFolderNameRequestSchema;
		output: typeof ValidateFolderNameResponseSchema;
	};
	/**
	 * @generated from rpc folder.v1.FolderService.ListFolders
	 */
	listFolders: {
		methodKind: "unary";
		input: typeof ListFoldersRequestSchema;
		output: typeof ListFoldersResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_folder_v1_folders, 0);
